import React, { Component, useContext } from 'react';
import { Nav } from 'reactstrap';
import { SideMenuItem } from './SideMenuItem';
import { SideMenuHeader } from './SideMenuHeader';
import { TenantContext } from '../../context/TenantContext';
import { urls } from '../../logic/urls';

import css from './SideMenu.module.scss';

class SideMenuInternal extends Component {
    render() {
        const AdministrationMenuRendered = <>
            <SideMenuHeader text="Administration" />
            <SideMenuItem text="Licensing" icon="file-alt" url={urls.license}/>
            {/* <SideMenuItem text="Portal access" icon="key" url={urls.portalAccess} /> */}
            <SideMenuItem text="API Documentation" icon="plug" url={urls.apiDocumentation}/>
        </>;

        const BasicMenuRendered = <>
            <SideMenuHeader text="Basic" />
            <SideMenuItem text="Global" icon="globe" url={urls.tenant} />
            <SideMenuItem text="Users" icon="user" url={urls.user}/>
            <SideMenuItem text="Contact Group" icon="users" url={urls.contactGroup}/>
            <SideMenuItem text="Device" icon="cogs" url={urls.device} />
        </>;

return (
            <div className={css.sideMenu}>
                <Nav vertical={true} tabs={false}>
                    <div className="flex-grow">
                        {AdministrationMenuRendered}
                        {BasicMenuRendered}
                    </div>
                </Nav>
            </div>
        );
    }
}

// Wrap the wrapped SideMenu component so that the UserContext and AdminConsentContext are accessible via the props.
export const SideMenu = (props) => {
    const tenantContext = useContext(TenantContext);
  
    return (
        <SideMenuInternal tenantContext={tenantContext} {...props}/>
    )
}